import { createFileRoute } from "@tanstack/react-router";
import { ResetPasswordScreen } from "@modules/account/views";
interface ResetPasswordSearch {
  token?: string;
}
export const Route = createFileRoute("/reset-password")({
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => ({
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  component: ResetPasswordRoute,
});
function ResetPasswordRoute() {
  const { token } = Route.useSearch();
  return <ResetPasswordScreen token={token ?? ""} />;
}
